export class Profile {
    name : string;
    emailID : string;
    mobileNo : string;
    roleName : string;
    supervisor : string;
    whLocation : string;
    regionCode : string;
}

export class Notify{
    notification : Notification[];
    unReadMsg : number;
}
export class RMH{
    rmhName : string;
}
export class Status{
    status : string;
}

export class Notification{
    id : number;
    notificationMessage : string;
    isActive : boolean;
    isRead : boolean;
}

export class UpdateNotification{
    ID : number;
    Read : boolean;
    Active : boolean;
}